const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`0c3d67ad0f73823e4184a171f4b70442698db3b7bc519335686e6a2f93f2c1e3`, `0c3d67ad0f73823e4184a171f4b70442698db3b7bc519335686e6a2f93f2c1e3`, 1, 134), new Map([[`class`, `o-deck--2-column@l`]]), true, false, 1));
            }

            getTemplateName() {
                return `0c3d67ad0f73823e4184a171f4b70442698db3b7bc519335686e6a2f93f2c1e3`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `0c3d67ad0f73823e4184a171f4b70442698db3b7bc519335686e6a2f93f2c1e3`, ``);
            }
        }],
        [134, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/deck/deck.twig`, `0c3d67ad0f73823e4184a171f4b70442698db3b7bc519335686e6a2f93f2c1e3`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/deck/deck.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable((context.has(`images`) ? context.get(`images`) : null));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`image`] = __value__;
                    this.echo(`      <figure>
        <img src="`);
                    this.echo(this.env.getFilter('escape').traceableCallable(7, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 7, this.source)(this.env, context.get(`image`), `src`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`" alt="">
        <figcaption>`);
                    this.echo(this.env.getFilter('escape').traceableCallable(8, this.source)(...[this.env, this.traceableMethod(this.getAttribute, 8, this.source)(this.env, context.get(`image`), `name`, new Map([]), `any`, false, false, false), `html`, null, true]));
                    this.echo(`</figcaption>
      </figure>
    `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('image');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`  `);
            }

            getTemplateName() {
                return `0c3d67ad0f73823e4184a171f4b70442698db3b7bc519335686e6a2f93f2c1e3`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `0c3d67ad0f73823e4184a171f4b70442698db3b7bc519335686e6a2f93f2c1e3`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '0c3d67ad0f73823e4184a171f4b70442698db3b7bc519335686e6a2f93f2c1e3');

let template = env.loadTemplate('0c3d67ad0f73823e4184a171f4b70442698db3b7bc519335686e6a2f93f2c1e3');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/design/demo/image-deck.twig", args: context }
     );
     return rendered;;
};